module.exports = __webpack_public_path__ + "assets/img/2021-midAutumn-btn2.1f680766.png";